export default {"src":"/_next/static/media/dk.d03b7087.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};